import Vue from 'vue';
import iview from 'iview';
import LayoutFreeSlotPanel from './layout/layout-free-slot-panel.vue'
import LayoutRowSlotPanel from './layout/layout-row-slot-panel.vue'
import LayoutColumnSlotPanel from './layout/layout-column-slot-panel.vue'
import BorderPanel from './layout/border-panel.vue';
import CommonPropEditor from './common-prop-editor/index.vue'
import flylineAttr from './flyline-attr/flyline-attr.vue';
import 'iview/dist/styles/iview.css';

Vue.use(iview);

let components = {
    "de-common-prop-editor":CommonPropEditor,
    "de-layout-free-slot-panel":LayoutFreeSlotPanel,
    "de-layout-row-slot-panel":LayoutRowSlotPanel,
    "de-layout-column-slot-panel":LayoutColumnSlotPanel,
    "de-border-default-panel":BorderPanel,
    "de-flyline-attr": flylineAttr
};

const install = function(Vue, options={}) {
    if (install.installed) return;
    install.installed = true;

    Object.keys(components).forEach(key => {
        Vue.component(key, components[key]);
    });
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

components.install = install;

export default components;